import React from "react"
import NavBar from "./general/nav_bar"
import Footer from "./general/footer"
import MainAboutUsSection from "./general/aboutUs/main_about_us_section"
import Description from "./general/aboutUs/description_about_us"
import CoreValues from "./general/aboutUs/values"

export default function AboutUs(){

    return(
        <>
            <MainAboutUsSection/>
            <Description/>
            <CoreValues/>
        </>
    )
}